function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 854.059998,
    y1: 146.529999,
    x2: 146.529999,
    y2: 854.059998,
    gradientTransform: "matrix(0.511698,0,0,0.511698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(14.509804%,22.745098%,29.411765%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "rgb(15.686275%,24.705882%,31.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "rgb(26.666667%,41.960784%,54.117647%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(31.372549%,49.019608%,62.745098%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 255.996094 0 C 114.617188 0 0 114.617188 0 255.996094 C 0 397.378906 114.617188 511.996094 255.996094 511.996094 C 397.378906 511.996094 511.996094 397.378906 511.996094 255.996094 C 511.996094 114.617188 397.382812 0 255.996094 0 Z M 184.148438 130.425781 L 202.136719 112.441406 C 204.40625 110.167969 208.09375 110.167969 210.363281 112.441406 L 245.773438 147.851562 L 219.558594 174.0625 L 184.148438 138.65625 C 181.878906 136.382812 181.878906 132.699219 184.148438 130.425781 Z M 110.003906 204.613281 L 127.992188 186.625 C 130.261719 184.355469 133.945312 184.355469 136.21875 186.625 L 171.628906 222.035156 L 145.414062 248.25 L 110.003906 212.839844 C 107.734375 210.570312 107.734375 206.882812 110.003906 204.613281 Z M 160.0625 303.191406 L 150.152344 313.101562 C 150.152344 313.101562 146.152344 317.097656 146.152344 317.097656 L 136.246094 327.003906 C 133.972656 329.277344 130.289062 329.277344 128.015625 327.003906 L 110.03125 309.019531 C 107.757812 306.746094 107.757812 303.0625 110.03125 300.792969 L 145.441406 265.382812 C 145.441406 265.382812 155.351562 255.46875 155.351562 255.46875 C 155.351562 255.46875 188.453125 222.367188 188.453125 222.367188 C 188.453125 222.367188 270.582031 140.242188 270.582031 140.242188 L 264.820312 134.480469 C 261.652344 131.3125 263.101562 125.910156 267.429688 124.746094 L 318.972656 110.9375 C 323.296875 109.78125 327.257812 113.734375 326.09375 118.058594 L 312.285156 169.601562 C 311.128906 173.925781 305.71875 175.375 302.550781 172.210938 L 296.789062 166.449219 L 160.0625 303.175781 Z M 320.359375 222.433594 L 294.144531 248.648438 L 262.988281 217.492188 L 289.203125 191.277344 Z M 246.21875 296.625 L 220.003906 322.839844 L 188.847656 291.683594 L 215.0625 265.46875 Z M 255.398438 357.191406 L 238.726562 373.863281 L 244.488281 379.625 C 247.65625 382.792969 246.207031 388.195312 241.878906 389.355469 L 190.335938 403.167969 C 186.011719 404.324219 182.050781 400.367188 183.214844 396.042969 L 197.023438 344.5 C 198.179688 340.175781 203.589844 338.730469 206.757812 341.890625 L 212.519531 347.652344 L 358.996094 201.175781 C 358.996094 201.175781 363.15625 197.015625 363.15625 197.015625 L 372.90625 187.265625 C 375.175781 184.996094 378.859375 184.996094 381.132812 187.265625 L 399.121094 205.253906 C 401.390625 207.523438 401.390625 211.207031 399.121094 213.480469 L 389.371094 223.226562 L 363.710938 248.890625 L 353.960938 258.636719 C 353.960938 258.636719 255.402344 357.195312 255.402344 357.195312 Z M 325.003906 383.636719 L 307.019531 401.621094 C 304.746094 403.894531 301.0625 403.894531 298.789062 401.621094 L 263.441406 366.273438 L 289.65625 340.058594 L 325.003906 375.40625 C 327.277344 377.679688 327.277344 381.363281 325.003906 383.636719 Z M 399.160156 309.460938 L 381.175781 327.445312 C 378.902344 329.71875 375.21875 329.71875 372.945312 327.445312 L 337.597656 292.097656 L 363.8125 265.882812 L 399.160156 301.230469 C 401.433594 303.503906 401.433594 307.1875 399.160156 309.460938 Z M 399.160156 309.460938 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d9740b138d5f8e23182ac2d59d2e85a5.svg";
export { ForwardRef as ReactComponent };